import { formatNumber } from '../../../../helpers/numbers'

export const columns = [
  {
    headTitle: 'Name',
    field: 'name'
  },
  {
    headTitle: 'Estimated Size',
    Component: ({ approximate_count_upper_bound }) =>
      approximate_count_upper_bound ? formatNumber(approximate_count_upper_bound) : '-',
    style: {
      width: '20%',
      textAlign: 'right'
    }
  }
]
